import React, { createContext, useState } from "react";
import axios from "axios";

export const CategoryContext = createContext();

export const CategoryProvider = (props) => {
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseUrl = "https://sawaapi.space";

  // Fetch all categories
  const fetchCategories = async () => {
    try {
      const response = await axios.get(baseUrl + "/api/v1/category");
      setCategory(response.data.data.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem("jwt");
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };

  // Create a new category
  const createCategory = async (categoryData) => {
    try {
      setLoading(true);
      await axios.post(baseUrl + "/api/v1/category", categoryData, getAuthHeaders());
      await fetchCategories();
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Failed to create Category.";
      setError(errorMessage);
      throw new Error(errorMessage); 
    } finally {
      setLoading(false);
    }
  };

  // Update an existing category
  const updateCategory = async (id, updatedData) => {
    try {
      setLoading(true);
      const response = await axios.patch(
        baseUrl + `/api/v1/category/${id}`,
        updatedData, getAuthHeaders()
      );
      setCategory((prevCategory) =>
        prevCategory.map((category) =>
          category._id === id ? response.data.data.data : category
        )
      );
      await fetchCategories();
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  // Delete an category
  const deleteCategory = async (id) => {
    try {
      setLoading(true);
      await axios.delete(baseUrl + `/api/v1/category/${id}`, getAuthHeaders());
      setCategory((prevCategory) =>
        prevCategory.filter((category) => category._id !== id)
      );
      await fetchCategories();
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <CategoryContext.Provider
      value={{
        category,
        loading,
        error,
        fetchCategories,
        createCategory,
        updateCategory,
        deleteCategory,
      }}
    >
      {props.children}
    </CategoryContext.Provider>
  );
};
